// src/utils/tafqeet.js
// تحويل المبلغ إلى كتابة عربية (التفقيط) — مثال:
//   tafqeet(3550.5) → "فقط ثلاثة آلاف وخمسمائة وخمسون ريال سعودي وخمسون هللة لا غير"

const ONES = ['', 'واحد', 'اثنان', 'ثلاثة', 'أربعة', 'خمسة', 'ستة', 'سبعة', 'ثمانية', 'تسعة'];
const TENS = ['', 'عشرة', 'عشرون', 'ثلاثون', 'أربعون', 'خمسون', 'ستون', 'سبعون', 'ثمانون', 'تسعون'];
const HUNDREDS = ['', 'مائة', 'مائتان', 'ثلاثمائة', 'أربعمائة', 'خمسمائة', 'ستمائة', 'سبعمائة', 'ثمانمائة', 'تسعمائة'];

// [مفرد، مثنى، جمع]
const SCALES = [
  null,
  ['ألف', 'ألفان', 'آلاف'],
  ['مليون', 'مليونان', 'ملايين'],
  ['مليار', 'ملياران', 'مليارات'],
];

function below100(n) {
  if (n === 0) return '';
  if (n < 10) return ONES[n];
  if (n === 10) return 'عشرة';
  if (n === 11) return 'أحد عشر';
  if (n === 12) return 'اثنا عشر';
  if (n < 20) return `${ONES[n - 10]} عشر`;
  const o = n % 10, t = Math.floor(n / 10);
  return o ? `${ONES[o]} و${TENS[t]}` : TENS[t];
}

function below1000(n) {
  const h = Math.floor(n / 100), rest = n % 100;
  return [HUNDREDS[h], below100(rest)].filter(Boolean).join(' و');
}

function groupWords(n, scaleIdx) {
  if (n === 0) return '';
  const scale = SCALES[scaleIdx];
  if (!scale) return below1000(n);
  if (n === 1) return scale[0];
  if (n === 2) return scale[1];
  if (n >= 3 && n <= 10) return `${below1000(n)} ${scale[2]}`;
  return `${below1000(n)} ${scale[0]}`;
}

export function numberToArabicWords(num) {
  let n = Math.floor(Math.abs(Number(num) || 0));
  if (n === 0) return 'صفر';
  const parts = [];
  let idx = 0;
  while (n > 0 && idx < SCALES.length) {
    const g = n % 1000;
    if (g) parts.unshift(groupWords(g, idx));
    n = Math.floor(n / 1000);
    idx++;
  }
  return parts.join(' و');
}

export function tafqeet(amount, { currency = 'ريال سعودي', fraction = 'هللة' } = {}) {
  const value = Math.round(Math.abs(Number(amount) || 0) * 100);
  const whole = Math.floor(value / 100);
  const cents = value % 100;
  if (!whole && !cents) return '';
  const parts = [];
  if (whole) parts.push(`${numberToArabicWords(whole)} ${currency}`);
  if (cents) parts.push(`${numberToArabicWords(cents)} ${fraction}`);
  return `فقط ${parts.join(' و')} لا غير`;
}

export default tafqeet;
